import React from 'react';
import { styled } from '@mui/material/styles';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../../auth/useAuth';

const PREFIX = 'Header';

const classes = {
    root: `${PREFIX}-root`,
    title: `${PREFIX}-title`,
    text: `${PREFIX}-text`,
    active: `${PREFIX}-active`,
    button: `${PREFIX}-button`,
    sectionDesktop: `${PREFIX}-sectionDesktop`,
    sectionMobile: `${PREFIX}-sectionMobile`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        flexGrow: 1,
    },

    [`& .${classes.title}`]: {
        flexGrow: 1,
        display: 'inline',
    },

    [`& .${classes.text}`]: {
        color: 'rgba(0,0,0,0.9)',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none',
        },
    },

    [`& .${classes.active}`]: {
        // backgroundColor: '#d8d8d8',
        borderRadius: '3px',
    },

    [`& .${classes.button}`]: {
        padding: theme.spacing(0, 2),
    },

    [`& .${classes.sectionDesktop}`]: {
        display: 'none',
        color: '#d8d8d8',
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
    },

    [`& .${classes.sectionMobile}`]: {
        display: 'flex',
        color: '#d8d8d8',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    }
}));

const Header = () => {

    const { logout } = useAuth();
    return (
        <Root className={classes.root}>
            <AppBar color="default" position="sticky">
                <Toolbar>
                    <Typography variant="h6" className={classes.title}>
                        <NavLink to="/" className={classes.text}>
                            ARCO Roster
                        </NavLink>
                    </Typography>
                    <div className={classes.sectionDesktop}>
                            <Button className={classes.button} onClick={() => window.print()}>
                                Print
                            </Button>
                    </div>
                    <div className={classes.sectionDesktop}>
                        <Link to="mailto:innovation@arcomurray.com?subject=Feedback-Roster" target='_blank' className={classes.text} activeclassname={classes.active}>
                            <Button className={classes.button}>
                                Feedback
                            </Button>
                        </Link>
                    </div>
                    <div className={classes.sectionDesktop}>
                            <Button className={classes.button} onClick={() => logout()}>
                                Logout
                            </Button>
                    </div>
                </Toolbar>
            </AppBar>
        </Root>
    );
};

export default Header;
